import React, { FC } from "react";
import styles from "./highlight-banner-skin-2.module.css";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { TypeOptionConfig, concatEllipsis } from "@commons-monorepo/index";
import { UiButton } from "@ui-monorepo/index";
import parse from "html-react-parser";
import { HighlightBannerProps } from "../../types";
import { useBannerNavigation } from "../../hooks";
import WidgetContainer from "../../../widget-container";

const HighlightBannerSkin2: FC<HighlightBannerProps> = ({
  data,
  config,
  type,
  log,
  theme
}) => {
  const { t } = useTranslation();
  const navigate = useBannerNavigation(config);
  const settings = {
    className: styles.highLightBannerSlider,
    dots: false,
    infinite: true,
    speed: 500,
    initialSlide: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true
  };
  const reverse = config?.banner_layout === TypeOptionConfig.layout2;
  const getImage = !!data?.images?.length ? data.images[0] : "";

  const navigateTo = (source: string) => {
    navigate(config?.banner_custom_information?.button_target);
  };

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      highlight
      style={{
        backgroundImage: `url(${getImage})`
      }}>

      <article
        className={`${styles.highlightBannerContainer} ${
        reverse ? styles.highlightBannerReverse : ""
        }`}>

        <div className={`${styles.headerBanner}`}>
          <h2 className={`${styles.title}`}>{data?.title}</h2>
        </div>
        <div className={`${styles.images}`}>
          <div className={`${styles.imagesSlider}`}>
            <Slider {...settings}>
              {data?.images?.map((image, index) => {
                return (
                  <figure
                    key={`image-slider-${index}`}
                    className={`${styles.figure}`}>

                    <img
                      loading={"lazy"}
                      className={`${styles.image}`}
                      onClick={() => {
                        if (config?.banner_custom_information?.show_cta) {
                          navigateTo(`image`);
                        }
                      }}
                      src={(image as string)}
                      alt={`${index}`} />

                  </figure>);

              })}
            </Slider>
          </div>
        </div>
        <div className={`${styles.info}`}>
          <div className={styles.description}>
            {parse(concatEllipsis(data?.description ?? "", 300))}
          </div>
          {config?.banner_custom_information?.show_cta &&
          <UiButton
            isWhite
            className={styles.button}
            onClick={() => navigateTo(`button`)}
            theme={theme}>

              {config?.banner_custom_information?.cta_text ||
            t("highLightBanner.more")}
            </UiButton>}

        </div>
      </article>
    </WidgetContainer>);

};

export default HighlightBannerSkin2;